import { EvoPathId } from "@repo/shared/types";

import axios from "../../api";

export type SaveOrShareSquadRequestData = {
  /** Overwrites this saved squad instead of adding one. */
  squadId?: string;
  name?: string;
  formation: string;
  players: {
    playerRoleId: number;
    resourceId: number;
    evoPathId?: EvoPathId;
    evolutionPath?: number[];
    pathwayPath?: number[][];
  }[];
  tacticId?: string;
  manager: {
    countryId: number;
    leagueId: number;
    eaId?: number;
  };
  tactic?: {
    name: string;
    description: string;
    logoUrl: string;
    teamTactics: {
      buildUpStyle: string;
      formationId: string;
      defensiveApproach: string;
      lineHeight: number;
    };
    playerRoles: {
      playerRoleId: number;
      focus?: string;
    }[];
  };
};

export type SaveSquadRes = {
  id: string;
  tacticId: string;
  name: string;
};

export const saveSquad = async (
  data: SaveOrShareSquadRequestData,
): Promise<SaveSquadRes> => {
  const res = await axios.post("/saved-squads", data);
  return res.data;
};
